import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Userservices from "../../services/Userservices";

interface ObjectType {
    Userprofiledata: any[];
}

const initialState: ObjectType = {
    Userprofiledata: [],
}

export const fetchuserprofiledata = createAsyncThunk(
    'fetchuserprofile',
    async (token: any) => {
        const response = await Userservices.getuserprofile(token)
        return response.data
    }
)

export const fetchuserprofiledataslice = createSlice({
    name: 'Userprofiledata',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchuserprofiledata.fulfilled.toString()]: (state, payload) => {
            state.Userprofiledata = payload.payload;
        }
    }
});

export const fetchuserprofiledatareducer = fetchuserprofiledataslice.reducer;